module.exports = __webpack_public_path__ + "img/icon_4.59095c02.png";